const WatchSvg = () => (
  <svg width="22" height="22" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.6223 9.87975C15.7933 11.0508 15.7933 12.9518 14.6223 14.1248C13.4513 15.2958 11.5503 15.2958 10.3773 14.1248C9.20627 12.9538 9.20627 11.0527 10.3773 9.87975C11.5503 8.70675 13.4503 8.70675 14.6223 9.87975"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 19C8.809 19 5.461 17.009 3.946 13.912V13.912C3.652 13.311 3.5 12.659 3.5 12C3.5 11.341 3.652 10.689 3.946 10.088V10.088C5.461 6.991 8.809 5 12.5 5C16.191 5 19.539 6.991 21.054 10.088V10.088C21.348 10.689 21.5 11.341 21.5 12"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 18H17"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 16V20"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default WatchSvg;
